'use client'

import React, { createContext, useEffect, useState } from 'react'

import { isSmallerScreen } from '../utils/device'

type WindowSizeProviderProps = {
  children: React.ReactNode
}

export const ResizeContext = createContext(0)

/**
 * This provider is added to resolve memory leak issue
 * which happens when we add a lot of duplicate resize
 * event listeners to the window
 */
export const WindowSizeProvider: React.FC<WindowSizeProviderProps> = ({
  children,
}: WindowSizeProviderProps) => {
  const [windowSize, setWindowSize] = useState<number>(0)

  const handleResize = () => {
    const isMobileOrTablet = isSmallerScreen()
    setWindowSize(isMobileOrTablet ? window?.screen?.width : window?.innerWidth)
  }

  useEffect(() => {
    handleResize()

    window?.addEventListener('resize', handleResize)
    return () => {
      window?.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <ResizeContext.Provider value={windowSize}>
      {children}
    </ResizeContext.Provider>
  )
}
